
export default {
  props: {
    media: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      videoPost: null,
      leafletLoaded: false,
      latLng: { lat: this.media.media_map.latitude, lng: this.media.media_map.longitude },
    };
  },
  computed: {
    mediaType () {
      return this.media.media_type;
    },
    image () {
      if (this.media.image) {
        return {
          src:
            this.media.image.sizes[`post-thumbnail`] ||
            this.media.image.sizes.full,
          alt: this.media.image.alt,
          title: this.media.image.title,
        };
      }
      return false;
    },
    imagePosition () {
      return this.media.image_position;
    },
    video () {
      if (this.media.content_media_type === `video`) {
        return {
          video: this.media.video,
          use_id: false,
        };
      } else if (this.media.content_media_type === `video-id`) {
        return {
          red_tv_video_id: this.media.red_tv_video_id,
          use_id: true,
        };
      }
      return false;
    },
  },
  methods: {
    zoomUpdate (zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate (center) {
      this.currentCenter = center;
    },
  },
};
